import React from 'react';
import VideoProgressContext from '../VideoProgressContext';

export default function VideoProgressProvider(props) {
  const { children } = props;
  return <VideoProgressContext.Provider>{children}</VideoProgressContext.Provider>;
}
